// DS1.7.11
import React from 'react';
import classnames from 'classnames';
import Locked16 from './16x16/Locked';
import Unlocked16 from './16x16/Unlocked';
import Locked24 from './24x24/Locked';
import Unlocked24 from './24x24/Unlocked';
import Locked32 from './32x32/Locked';
import Unlocked32 from './32x32/Unlocked';
import Locked40 from './40x40/Locked';
import Unlocked40 from './40x40/Unlocked';
import s from './TierBadge.scss';
const lockedSizes = {
    16: Locked16,
    24: Locked24,
    32: Locked32,
    40: Locked40
};
const unlockedSizes = {
    16: Unlocked16,
    24: Unlocked24,
    32: Unlocked32,
    40: Unlocked40
};
const TierBadge = ({ size , isLocked , className , useSecondaryColor ,  })=>{
    const Component = isLocked ? lockedSizes[size] : unlockedSizes[size];
    return /*#__PURE__*/ React.createElement(Component, {
        className: classnames(s['root'], s[`size-${size}`], useSecondaryColor && s['secondary-color'], className)
    });
};
TierBadge.displayName = 'TierBadge';
export default TierBadge;
